/**
 * Comprime/redimensiona una imagen (File) a un JPEG base64 liviano, para que el upload
 * de fotos del fletero no supere los límites del servidor (una foto full-res de celular
 * en base64 puede pesar 5-15 MB). Devuelve un dataURL (string).
 */
export function comprimirImagen(file, maxLado = 1280, calidad = 0.7) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onerror = reject
    reader.onload = e => {
      const img = new Image()
      img.onerror = reject
      img.onload = () => {
        let { width, height } = img
        if (width > maxLado || height > maxLado) {
          if (width >= height) { height = Math.round(height * maxLado / width); width = maxLado }
          else { width = Math.round(width * maxLado / height); height = maxLado }
        }
        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        canvas.getContext('2d').drawImage(img, 0, 0, width, height)
        try {
          resolve(canvas.toDataURL('image/jpeg', calidad))
        } catch (err) {
          reject(err)
        }
      }
      img.src = e.target.result
    }
    reader.readAsDataURL(file)
  })
}
